import { getApiClientVigo } from "./ApiClientVigo.js";

/**
 * Holt die Tarifinformationen vom Backend
 * @returns {Promise<Object>} API Response mit Tarifinfos
 */
export async function getTarifinfos() {
    const client = getApiClientVigo();
    return client.get('/v2/tarifrechner/tarifinfos');
}

